(() => {
  'use strict';

  const current = document.currentScript?.src || '';
  const sibling = (name) => current.replace(/product-form\.js(?:\?.*)?$/, name);
  const load = (name) =>
    new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = sibling(name);
      script.defer = true;
      script.onload = resolve;
      script.onerror = () => reject(new Error(`Unable to load ${name}`));
      document.head.appendChild(script);
    });

  load('product-form-dual-run-r1-backup.js')
    .then(() => load('som-cloudflare-authoritative-r1.js'))
    .then(() => load('som-cloudflare-diagnostics-visibility-r1.js'))
    .then(() => load('som-colour-mobile-label-fix-r1.js'))
    .then(() => load('som-colour-preview-r2.js'))
    .catch((error) => console.error('[SOM Cloudflare loader]', error));
})();
